import React from "react";
import { motion } from "framer-motion";
import { Shield, Heart, Award, Briefcase, Eye, Leaf } from "lucide-react";
import { useI18n } from "../i18n";

const WhyUs = () => {
  const { t } = useI18n();
  const items = [
    { Icon: Shield, ...t.whyus.guven },
    { Icon: Heart, ...t.whyus.memnuniyet },
    { Icon: Award, ...t.whyus.kalite },
    { Icon: Briefcase, ...t.whyus.profesyonellik },
    { Icon: Eye, ...t.whyus.seffaflik },
    { Icon: Leaf, ...t.whyus.surdurulebilir },
  ];

  return (
    <section
      id="whyus"
      className="relative py-24 md:py-32 bg-[var(--bg)] overflow-hidden"
      data-testid="whyus-section"
    >
      <div className="absolute inset-0 bp-overlay opacity-50 pointer-events-none" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16"
        >
          <div className="lg:col-span-6">
            <div className="overline mb-4">{t.whyus.overline}</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-white leading-[1.05]">
              {t.whyus.title}
            </h2>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(({ Icon, title, desc }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="border border-[var(--border)] p-8 md:p-10 hover:border-white/40 transition-colors group"
              data-testid={`whyus-card-${i}`}
            >
              <Icon size={32} strokeWidth={1.25} className="text-[var(--silver)] mb-8 group-hover:text-white transition-colors" />
              <h3 className="font-display text-xl font-medium text-white mb-3 leading-tight">{title}</h3>
              <p className="text-sm leading-relaxed text-[var(--text-muted)]">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
